import DomComponent from '../../lib/domComponent';
import { each, getCookie, setCookie } from '../../lib/util';

export default class EmergencyAlertComponent extends DomComponent {
    static selector = '[data-js-emergency-alert]';

    constructor(el) {
        super(el);

        if(!this.el) {
            return;
        }
        this.hasBeenClosed = false;
        this.mobileNavButton = document.querySelectorAll('.header [data-toggle]');
        // each(this.mobileNavButton, (button) => {
        //     button.addEventListener('click', this.close.bind(this));
        // });

        this.id = this.el.dataset.jsEmergencyAlert;
        this.bodyClass = `emergency-alert-visible--${this.id}`;
        this.cookieName = `close-${this.id}`;
        const alreadyClosed = false;//getCookie(this.cookieName);
        this.hasBeenClosed = alreadyClosed;
        setTimeout(() => {
            if(!alreadyClosed) {
                this.el.classList.add('visible');
                document.body.classList.add(this.bodyClass);
                const box = this.el.querySelector('[data-box]');

                this.closeButtons = this.el.querySelectorAll('[data-close]');

                each(this.closeButtons, button => button.addEventListener('click', this.close))

                if(this.id === 'popup') {
                    box.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    setTimeout(() => {
                        document.addEventListener('click', this.close);
                    })
                }

                if(this.id === 'banner') {
                    const height = this.el.offsetHeight;
                    this.height = height;

                    this.header = document.querySelector('[data-js-header]');
                    this.layout = document.querySelector('[data-layout]');


                    this.layout.style.marginTop = `${height}px`;
                    this.header.style.top = `${height}px`;

                }
            }
        });

        setTimeout(() => {
            this.loaded();
        });

        this.el.addEventListener('alert:collapse', () => {
            if (!this.hasBeenClosed) {
                this.layout.style.marginTop = '0px';
                this.header.style.top = '0px';
                this.el.classList.remove('visible');
            }
        });

        this.el.addEventListener('alert:expand', () => {
            if (!this.hasBeenClosed) {
                this.el.classList.add('visible');
                this.layout.style.marginTop = `${this.height}px`;
                this.header.style.top = `${this.height}px`;
            }
        });
    }

    close = () => {
        this.hasBeenClosed = true;
        this.el.classList.remove('visible');
        document.body.classList.remove(this.bodyClass);
        //if (this.id !== 'popup') setCookie(this.cookieName, true);

        if(this.id === 'popup') {
            setTimeout(() => {
                document.removeEventListener('click', this.close);
            })
        }

        if(this.id === 'banner') {
            this.layout.style.marginTop = '0px';
            this.header.style.top = '0px';
        }
    }
}